import React, { useEffect, useRef } from "react";

const RandomFloating = ({
  className = "",
  children,
  positionResetIn = 2000,
  movementSpace = 10,
  transitionSpeed = 2,
}) => {
  const cardRef = useRef(null);

  useEffect(() => {
    if (!cardRef.current) return;

    const moveCard = () => {
      if (cardRef.current) {
        const randomX =
          Math.random() * movementSpace * (Math.random() > 0.5 ? 1 : -1);
        const randomY =
          Math.random() * movementSpace * (Math.random() > 0.5 ? 1 : -1);
        cardRef.current.style.transition = `transform ${transitionSpeed}s ease-in-out`;
        cardRef.current.style.transform = `translate(${randomX}px, ${randomY}px)`;
      }
      setTimeout(moveCard, positionResetIn);
    };

    moveCard();
  }, [movementSpace, positionResetIn]);

  return (
    <div ref={cardRef} className={className}>
      {children}
    </div>
  );
};

export default RandomFloating;
